import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { EditSoundModel } from "../EditSoundModel";
import { DataService_SoundMaintenance } from "../shared/data.service";

@Component({
	selector: "app-edit-sound",
	templateUrl: "./edit-sound.component.html",
	styleUrls: ["./edit-sound.component.css"],
})
export class EditSoundComponent implements OnInit {
	constructor(
		public ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private adminSetupService: DataService_SoundMaintenance,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.SelectedSound = this.dialogConfig.data.SelectedSound;
		this.SoundName = this.dialogConfig.data.SelectedSound.SoundName;
		this.SchoolID = this.dialogConfig.data.SchoolID;

		this.user = this.dialogConfig.data.user;

		this.SchoolOptionID = this.SelectedSound.UsedBy == "District" ? 2 : 1;

		this.LoadSoundData();
	}

	/////////////////////////////////////////
	// Data
	/////////////////////////////////////////
	user: any;
	SelectedSound: any;
	SoundName: any;

	SchoolID: any;

	SchoolOptionID: any = 1;
	lstSchoolOption: any = [
		{
			ID: 1,
			Desc: "This School Only",
		},
		{
			ID: 2,
			Desc: "District",
		},
	];

	SoundData: any;
	CurrentSound: any = new Audio();

	loading: any;

	errorMessage: any;
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////
	LoadSoundData() {
		this.loading = true;
		//Get Sound's data from DB
		var result = this.adminSetupService.loadSoundFile("", this.SelectedSound.SoundLibraryID);
		result.subscribe(
			(response) => {
				//
				//Create Mp3 File
				//

				//Get base64 Data
				var base64 = response[0];

				//Turn data into sound blob (formatted raw data)
				// this.SoundData = this.dataURIToMP3Blob(base64);

				this.SoundData = base64;

				this.loading = false;
			},
			(error) => {}
		);
	}
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////
	onPlayCurrent() {
		this.errorMessage = "";

		try {
			//Create URL from the soud blob
			var url = window.URL.createObjectURL(this.dataURIToMP3Blob(this.SoundData));

			//Open file for testing purposes
			//var pwa = window.open(url);

			this.CurrentSound.src = url;
			this.CurrentSound.load();
			this.CurrentSound.play();

			//this.audio.currentTime = 0;
		} catch (e) {
			e.toString();

			try {
				this.CurrentSound = new Audio(this.SoundData);
				this.CurrentSound.load();
				this.CurrentSound.play();
			} catch (e2) {
				e2.toString();
			}
		}
	}

	onPause() {
		this.errorMessage = "";

		if (this.CurrentSound.src != null && this.CurrentSound.currentTime > 0) {
			this.CurrentSound.pause();
			this.CurrentSound.currentTime = 0;
		}
	}

	onUploadNew() {
		this.errorMessage = "";

		this.onPause();

		document.getElementById("EditSoundInput").click();
	}

	onEdit() {
		this.errorMessage = "";

		this.onPause();

		//Test current Sound
		if (this.SoundName == "") {
			this.errorMessage = "Enter a sound name";
			return;
		}

		if (this.isWavCheck(this.SoundName, this.SoundData) == true) {
			if (this.CheckSizeLimit(this.SoundData, "wav") == true) {
				this.FinishEdit("wav");
			}
		} else if (this.isMP3Check(this.SoundName, this.SoundData) == true) {
			if (this.CheckSizeLimit(this.SoundData, "mp3") == true) {
				this.FinishEdit("mp3");
			}
		} else {
			this.errorMessage =
				"ERROR: Invalid sound file. Make sure the sound name ends in '.mp3' or '.wav' (ex. ExampleSound.mp3) and matches the file type (renaming EX.wav to EX.mp3 won't work)";
			return;
		}
	}

	CheckSizeLimit(soundData, type) {
		//WAV, 10MB limit
		if (type == "wav") {
			if (soundData.length / 1024 / 1024 > 10) {
				this.errorMessage = "Could Not Add Sound File. WAV file larger than 10 MB";
				return false;
			} else {
				return true;
			}
		}
		//Mp3, 2MB limit
		else if (type == "mp3") {
			if (soundData.length / 1024 / 1024 > 2) {
				this.errorMessage = "Could Not Add Sound File. Mp3 file larger than 2 MB";
				return false;
			} else {
				return true;
			}
		}
	}

	FinishEdit(FType) {
		var SID = this.SchoolID;
		if (this.SchoolOptionID == 2) {
			SID = -1;
		}

		//Create Model
		let requestModel: EditSoundModel = {
			SoundLibraryID: this.SelectedSound.SoundLibraryID,
			// SchoolID: SID,
			SoundName: this.SoundName,
			SoundData: this.SoundData,
			FileType: FType,
		};

		//Call SP
		var result = this.adminSetupService.EditSoundFile(requestModel);
		result.subscribe(
			(response) => {
				//
				// CONFIRM DIALOG FOR RESULTS
				//
				var SuccessMessage = "Mp3 file updated successfully";

				if (FType == "wav") {
					SuccessMessage = "WAV file updated successfully";
				}

				//File added successfully
				if (response) {
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: SuccessMessage,
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				}
				//File not added (File name already in DB)
				else {
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Add Sound File. File with the same name is already in the Database.",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				// this.SelectedSound = null;
			},
			(error) => {}
		);
	}

	onClose() {
		this.onPause();

		this.ref.close(0);
	}
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Events
	/////////////////////////////////////////
	onSoundChange(val) {
		var file: File = val.target.files[0];

		if (file) {
			this.loading = true;

			this.onPause();

			var fr = new FileReader();
			fr.readAsDataURL(file);
			fr.onload = () => {
				this.SoundData = fr.result;

				this.loading = false;

				//New Version

				//Check if file is a sound
				var AudioTest;
				try {
					AudioTest = new Audio(this.SoundData);
				} catch (e) {
					AudioTest.onerror = (event) => {
						this.errorMessage = "Could Not Add Sound File. Not a Valid Audio File.";
					};
				}

				AudioTest.oncanplaythrough = (event) => {};

				AudioTest.onerror = (event) => {
					this.errorMessage = "Could Not Add Sound File. Not a Valid Audio File.";
				};
			};
		} else {
			this.errorMessage = "Could not read file";
		}
	}
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////
	dataURIToMP3Blob(val) {
		const byteString = window.atob(val);
		const arrayBuffer = new ArrayBuffer(byteString.length);
		const int8Array = new Uint8Array(arrayBuffer);
		for (let i = 0; i < byteString.length; i++) {
			int8Array[i] = byteString.charCodeAt(i);
		}
		const blob = new Blob([int8Array], { type: "audio/mpeg" });
		return blob;
	}

	NotDistrictUser() {
		return this.user.UserLevelID != 1;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	isWavCheck
	//
	//-----------------------------------------------------------------------------------------------------
	isWavCheck(fileName: string, base64: string) {
		let isWav: boolean = false;
		let bytes: Uint8Array;

		//
		//	File Name must end in .wav
		//
		if (fileName.substr(-4, 4).toLowerCase() != ".wav".toLowerCase()) {
			return isWav;
		}

		bytes = this.base64StringToUint8Array(base64);

		//  The canonical WAVE format starts with the RIFF header:
		//
		//  Offset  Size Name       Description
		//  -----   ---- ---------- ------------------------------------------------------------------------
		//  0       4    ChunkID    Contains the letters "RIFF" in ASCII form (0x52494646 big - endian form).
		//  4       4    ChunkSize  36 + SubChunk2Size, or more precisely:
		//                          4 + (8 + SubChunk1Size) + (8 + SubChunk2Size)
		//                          This is the size of the rest of the chunk following this number.
		//                          This is the size of the entire file in bytes minus 8 bytes for the
		//                          two fields not included in this count: ChunkID and ChunkSize.
		//  8       4    Format     Contains the letters "WAVE" (0x57415645 big - endian form).
		if (
			bytes[0] == 0x52 &&
			bytes[1] == 0x49 &&
			bytes[2] == 0x46 &&
			bytes[3] == 0x46 &&
			bytes[8] == 0x57 &&
			bytes[9] == 0x41 &&
			bytes[10] == 0x56 &&
			bytes[11] == 0x45
		) {
			isWav = true;
		}

		return isWav;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	isMP3Check
	//
	//-----------------------------------------------------------------------------------------------------
	isMP3Check(fileName: string, base64: string) {
		let isMp3: boolean = false;
		let bytes: Uint8Array;

		//
		//	File Name must end in .mp3
		//
		if (fileName.substr(-4, 4).toLowerCase() != ".mp3".toLowerCase()) {
			return isMp3;
		}

		bytes = this.base64StringToUint8Array(base64);

		//
		// 	File starts with: 0x49 0x44 0x33		("ID3")
		//	or
		// 	File starts with: 0xFF 0xFB | 0xFF 0xF3 | 0xFF 0xE3 | 0xFF 0xFA | 0xFF 0xF2 | 0xFF 0xE2
		//
		// 	BITS					HEX			MPEG version ID								Layer		CRC Protection
		// 	-------------------		-----		---------------------------	------------	---------	-------------------------
		// 	11111111111 11 01 1		FF FB		MPEG Version 1								Layer III	Not protected	(No CRC)
		// 	11111111111 10 01 1		FF F3		MPEG Version 2								Layer III	Not protected	(No CRC)
		// 	11111111111 00 01 1		FF E3		MPEG Version 2.5 (not official standard)	Layer III	Not protected	(No CRC)
		//
		// 	11111111111 11 01 0		FF FA		MPEG Version 1								Layer III	Protected by CRC
		// 	11111111111 10 01 0		FF F2		MPEG Version 2								Layer III	Protected by CRC
		// 	11111111111 00 01 0		FF E2		MPEG Version 2.5 (not official standard)	Layer III	Protected by CRC
		//
		if (
			(bytes[0] == 0x49 && bytes[1] == 0x44 && bytes[2] == 0x33) ||
			(bytes[0] == 0xff && bytes[1] == 0xfb) ||
			(bytes[0] == 0xff && bytes[1] == 0xf3) ||
			(bytes[0] == 0xff && bytes[1] == 0xe3) ||
			(bytes[0] == 0xff && bytes[1] == 0xfa) ||
			(bytes[0] == 0xff && bytes[1] == 0xf2) ||
			(bytes[0] == 0xff && bytes[1] == 0xe2)
		) {
			isMp3 = true;
		}

		return isMp3;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	base64StringToUint8Array
	//
	//-----------------------------------------------------------------------------------------------------
	base64StringToUint8Array(base64: string) {
		if (String(base64).substr(0, 11) == "data:audio/") {
			base64 = base64.split(",")[1];
		}

		let binary_string = window.atob(base64);
		let len = binary_string.length;
		let bytes = new Uint8Array(len);

		for (let i = 0; i < len; i++) {
			bytes[i] = binary_string.charCodeAt(i);
		}

		return bytes;
	}

	/////////////////////////////////////////
}
